import script from "./STKN06_013INS.vue?vue&type=script&setup=true&lang=js"
export * from "./STKN06_013INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__